import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-select-card',
    templateUrl: './select-card.component.html',
    styleUrls: ['./select-card.component.scss'],
    imports: [NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectCardComponent {
  @Input() active = false;
}
